var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var WishLists = function () {
	this.$tabsUl = $( document.querySelector( '#wishlists-tabs' ) );
	this.$miniCartQty = $( document.querySelectorAll( '.wishlists-menu .cart_list .quantity-button' ) );
	this.$removeItem = $( document.querySelectorAll( '.wishlists-menu .mini-cart-remove' ) );
};

WishLists.prototype.init = function () {

	var self = this,
		$quantity, quantKey, quantVal;

	$( document )
		.on( 'click', 'ul.tabs li', function () {
			var tab_id = $( this ).data( 'tab' );

			$( 'ul.tabs li' ).removeClass( 'current' );
			$( '.tab-content' ).removeClass( 'current' );

			$( this ).addClass( 'current' );
			$( "#" + tab_id ).addClass( 'current' );
		} )
		.on( 'click', '.wishlists-menu .cart_list .quantity-button', function ( e ) {
			e.preventDefault();

			$quantity = $( this ).siblings( 'span' ).children( '.quantity-value' );
			quantKey = $( this ).data( 'key' );
			quantVal = parseInt( $quantity.text() );

			if ( $( this ).hasClass( 'inc' ) ) {
				quantVal ++;
			} else if ( quantVal > 1 ) {
				quantVal --;
			} else {
				quantVal = 1;
			}

			$quantity.text( quantVal );

		} )
		.on( 'click', '.wishlists-menu .mini-cart-remove', function ( e ) {

			e.preventDefault();

			var cart_items = $( this ).parents( 'li.mini_cart_item' ).siblings( 'li' );
			$( this ).parents( 'li.mini_cart_item' ).remove();

			if ( cart_items.length === 0 ) {

				$( document.getElementsByClassName( 'cart_list' ) )
					.addClass( 'empty' )
					.html( '<li class="empty">No products in the cart.</li>' );

				$( '.mini-cart-not-empty' ).remove();
			}

		} );

};

module.exports = new WishLists;
